import type { Me } from '@yandex-int/k-common';
import { getMe, postAcceptPersonalDataAndTos } from '@yandex-int/k-common/client/api';
import { call, put, takeLatest } from 'redux-saga/effects';

import * as userActions from '../user/actions';

import { personalDataModalActions } from './actions';

export function* acceptPersonalDataWatcher() {
    yield takeLatest(personalDataModalActions.acceptPersonalDataRequest, acceptPersonalDataSaga);
}

function* acceptPersonalDataSaga(action: ReturnType<typeof personalDataModalActions.acceptPersonalDataRequest>) {
    try {
        const { onSuccess } = action.payload || {};
        yield call(postAcceptPersonalDataAndTos);

        const me: Me = yield call(getMe);
        yield put(userActions.setMe(me));

        yield put(personalDataModalActions.acceptPersonalDataSuccess());

        if (onSuccess) {
            onSuccess();
        }
    } catch (error) {
        console.error(error);
        yield put(personalDataModalActions.acceptPersonalDataError());
    }
}
